<template>
	<div>
		<NavMenu/>
		<div class="CourseDetailWarp">
			<div class="meetInfoBox">
				<div class="filebox">
					<!-- :src="srcUrl+CourseDetailObj.trainPhoto" -->
					<img src="@/assets/imgs/train/three.png" v-if="CourseDetailObj.isSkip==2" />
					<img src="@/assets/imgs/home/course.png" v-else />
					<div class="file" v-if="applyDataUrlList.length!=0">
						<div class="fileitem" v-for="(item,index) in applyDataUrlList" :key="index" @click="persondownloadFn(item)">
							<img src="@/assets/imgs/home/uploadfileicon.png" />
							<span>
								{{item.substr(item.lastIndexOf('-') + 1)}}
							</span>
						</div>

					</div>
				</div>
				<div class="infobox">
					<div class="namebox">{{CourseDetailObj.trainCourse}}</div>
					<div class="otherinfo">
						<div>课程编码：{{CourseDetailObj.trainCode}}</div>
						<div>课程起止时间：{{CourseDetailObj.startTime}} 至{{CourseDetailObj.endTime}}</div>
						<div>培训地点：{{CourseDetailObj.trainSite}}</div>
						<div>招报人数：{{CourseDetailObj.playNumber}}</div>
					</div>
					<div class="deadline">
						报名截止：{{CourseDetailObj.deadline}}
					</div>
					<div class="moneybox">
						{{CourseDetailObj.pay}}
						<!-- <span>元/人</span> -->
					</div>
					<div class="handlebox">
						<!-- <div class="applybox">立即报名</div> -->
						<div v-if="!CourseDetailObj.isApply">
							<div v-if="CourseDetailObj.factNumber==CourseDetailObj.playNumber" class="registeredbox">
								已满员
							</div>
							<div v-else class="applybox" @click="singUpFn(CourseDetailObj)">
								立即报名
							</div>
						</div>
						<div v-else>
							<div class="applybox" style="cursor: pointer;" v-if="CourseDetailObj.isApply!='报名截止'&&CourseDetailObj.isApply!='已结束'" @click="singUpFn(CourseDetailObj)">
								{{CourseDetailObj.isApply}}
							</div>
							<div class="registeredbox" v-if="CourseDetailObj.isApply=='报名截止'">
								{{CourseDetailObj.isApply}}
							</div>
							<div class="coursdeadline" v-if="CourseDetailObj.isApply=='已结束'">
								{{CourseDetailObj.isApply}}
							</div>
						</div>
						<div class="returnbox" @click="returnFn">返回</div>
					</div>
				</div>
			</div>
			<div class="primaryTitle">
				<span class="left-line"></span>
				<span class="title">课程介绍</span>
				<span class="right-line"></span>
			</div>

			<div class="centerbox">
				<div class="detail-newscontent" v-html="CourseDetailObj.remark"></div>
			</div>
			<!-- <div class="other-news-box">
                <div class="other-news">
                    <div v-if="CourseDetailObj.newsLast" @click="lastNewsFn(CourseDetailObj.newsLast.pressId)">
                        上一篇：{{ CourseDetailObj.newsLast.pressTopic }}
                    </div>
                    <div v-if="CourseDetailObj.newsNext" @click="nextNewsFn(CourseDetailObj.newsNext.pressId)">
                        下一篇：{{ CourseDetailObj.newsNext.pressTopic }}
                    </div>
                </div>
                <div @click="returnPage" class="return-box">【返回列表】</div>
            </div> -->
		</div>
		<Footer/>
		<el-dialog title="" :visible.sync="loginVisible" width="805px" class="dialogWarp" :destroy-on-close="true" :close-on-click-modal='false'>
			<div class="dialogcenter">
				<h3>报名请先登录</h3>
				<span class="text">
					此功能为网站用户开放，如需报名请先登录
				</span>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="gologin">登录</el-button>
				<el-button @click="offloginVisible">不用了,谢谢</el-button>
			</span>
		</el-dialog>
		<CourseSingupModal :isShow.sync="singupVisible" v-if="singupVisible" :currentCourse='CourseDetailObj' @successApplyFn='successApplyFn'
		/>
	</div>
</template>
<script>
import NavMenu from '@/components/navMenu.vue'
import Footer from '@/components/footer.vue'
import CourseSingupModal from './CourseSingupModal.vue'
// import ReturnTop from "@/components/returnTop.vue";
import { httpService, srcUrl } from "@/service/httpService";
export default {
	components: {
		NavMenu,
		Footer,
		CourseSingupModal
		// ReturnTop
	},
	data() {
		return {
			srcUrl: srcUrl,
			CourseDetailObj: {},
			applyDataUrlList: [],
			token: sessionStorage.getItem('token'),
			loginVisible: false,
			singupVisible: false,
			id: null,
			childMenu: null

		}
	},
	created() {
		let data = JSON.parse(sessionStorage.getItem('childMenuObj'))
		if (data) {
			this.childMenu = data
		}
		else {
			this.childMenu = JSON.parse(sessionStorage.getItem('currentNew'))
		}
	},
	mounted() {
		this.id = this.$route.query.id || this.$route.params.id;
		this.getCourseDetail(this.id);

	},
	methods: {
		async getCourseDetail(id) {
			let data = await httpService.getTrainCourse(id);
			if (data.code == "200") {
				this.CourseDetailObj = data.result;
				if (this.CourseDetailObj.applyDataUrl) {
					this.applyDataUrlList = this.CourseDetailObj.applyDataUrl.split(',')
				}
				document.body.scrollTop = 0;
				document.documentElement.scrollTop = 0;
			} else {
				this.$message.error(data.message);
			}
		},
		// 下载
		persondownloadFn(item) {
			let Docurl = `${
				process.env.VUE_APP_GATEWAY
				}${"/upload/download?session="}${item}`;
			let a = document.createElement("a");
			document.body.appendChild(a);
			a.style.display = "none";
			a.setAttribute("download", "");
			a.setAttribute("target", "_self");
			a.setAttribute("href", Docurl);
			a.click();
			document.body.removeChild(a);
		},
		singUpFn(val) {
			if (this.token) {
				if (this.CourseDetailObj.isSkip == 2) {
					window.open(this.CourseDetailObj.webSite, "blank");
				} else {
					// 弹报名框
					this.singupVisible = true
					this.stopScroll()
					this.currentCourse = val
				}
			}
			else {
				// 提示登录
				this.loginVisible = true
			}
		},
		offloginVisible() {
			this.loginVisible = false
		},
		gologin() {
			this.$router.push('/login');
		},
		successApplyFn() {
			this.singupVisible = false;
			this.canScroll()
			this.getCourseDetail(this.id);
		},
		// goapply(){
		// 	this.$router.push({
		// 		path: "/account-center/course-applydetail",
		// 		query: {
		// 			id: this.id,
		// 		},
		// 	});
		// }
		returnFn() {
			let currentNew = JSON.parse(sessionStorage.getItem('currentNew'))
			if (currentNew) {
				this.$router.push(currentNew.menuurl);
			} else {
				this.$router.go(-1)
			}
			// if (this.childMenu) {
			// 	this.$router.push(this.childMenu.linkUrl || this.childMenu.menuurl);
			// } else {
			// 	this.$router.push('/train-service')
			// }
		}
	},
	// filters: {
	//     timer: (value) => {
	//         return value.substring(0, 10);
	//     },
	// },
}
</script>
<style lang="less" scoped>
.CourseDetailWarp {
	padding: 50px 0 0 0;
	.meetInfoBox {
		width: 1200px;
		margin: 0 auto;
		display: flex;
		flex-direction: row;
		.filebox {
			img {
				width: 620px;
				height: 310px;
			}
			.file {
				display: flex;
				flex-direction: row;
				cursor: pointer;
				margin: 20px 0 0 0;
				.fileitem {
					display: flex;
					flex-direction: row;
					align-items: center;
					cursor: pointer;
					margin-right: 45px;
					img {
						width: 18px;
						height: 18px;
					}
					span {
						font-size: 16px;
						line-height: 32px;
						color: #bdbdbd;
					}
				}
			}
		}

		.infobox {
			margin-left: 30px;
			.namebox {
				font-size: 22px;
				line-height: 35px;
				color: #333333;
				margin-bottom: 20px;
			}
			.otherinfo {
				color: #666666;
				font-size: 16px;
				line-height: 32px;
			}
			.deadline {
				color: #bdbdbd;
				font-size: 16px;
				line-height: 32px;
			}
			.moneybox {
				width: 447px;
				height: 45px;
				background: #f4f4f4;
				font-size: 22px;
				line-height: 45px;
				color: #f34a4a;
				padding-left: 15px;
				margin: 14px 0 24px 0;
				.moneybox {
					font-size: 16px;
				}
			}
			.handlebox {
				display: flex;
				flex-direction: row;
				font-size: 16px;
				.applybox {
					width: 183px;
					height: 54px;
					line-height: 54px;
					cursor: pointer;
					text-align: center;
					background: #448df7;
					color: #fff;
				}
				.registeredbox {
					background: #4ab344;
					color: #fff;
					cursor: not-allowed;
					width: 183px;
					height: 54px;
					line-height: 54px;
					text-align: center;
				}
				.coursdeadline {
					background: #c0c0c0;
					color: #fff;
					cursor: not-allowed;
					width: 183px;
					height: 54px;
					line-height: 54px;
					text-align: center;
				}

				.returnbox {
					width: 181px;
					height: 52px;
					line-height: 52px;
					cursor: pointer;
					text-align: center;
					background: #fff;
					border: 1px solid #448df7;
					color: #448df7;
					margin: 0px 0px 0 24px;
				}
			}
		}
	}
	.detail-newsTitle {
		font-size: 26px;
		font-weight: bold;
		line-height: 35px;
		color: #333333;
		text-align: center;
		position: relative;
		border-bottom: 1px solid #dddddd;
		padding-bottom: 10px;
	}
	.detail-newsTitle::before {
		content: '';
		position: absolute;
		width: 68px;
		height: 0px;
		border: 2px solid #448df7;
		opacity: 1;
		background: #448df7;
		left: 50%;
		transform: translateX(-50%);
		top: 42px;
	}
	.centerbox {
		width: 1000px;
		margin: 0 auto 40px auto;
		.time {
			margin: 20px 0 40px 0;
			line-height: 47px;
			color: #cacaca;
		}
		.detail-newscontent {
			/deep/img {
				width: 100%;
			}
		}
	}
}
.dialogWarp {
	.dialogcenter {
		padding: 17px 60px 0px 60px;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		h3 {
			font-size: 22px;
			font-weight: bold;
			line-height: 32px;
			color: #333333;
			margin-bottom: 46px;
		}
		.text {
			height: 145px;
			font-size: 16px;
			line-height: 30px;
			color: #666666;
		}
	}
}
</style>


